/* src/app/shared/components/button/button.component.scss */
:host:active {
  box-shadow: none;
}
button {
  width: 100%;
}
/*# sourceMappingURL=button.component.css.map */
